import { useState, useEffect } from 'react';
import galleryApi from '../services/galleryApi';

/**
 * Hook to check if gallery is enabled for the club
 * Returns true if club has at least one active gallery image
 *
 * NOTE: Gallery is currently hidden - always returns false
 */
export const useGalleryStatus = () => {
  const [isGalleryEnabled, setIsGalleryEnabled] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Gallery is disabled - skip checking
    // Uncomment to re-enable: checkGalleryStatus();
  }, []);

  const checkGalleryStatus = async () => {
    try {
      setLoading(true);
      // Use public endpoint since gallery is public
      const response = await galleryApi.getCarouselData();
      const images = response.data?.images || [];
      setIsGalleryEnabled(images.length > 0);
    } catch (error) {
      console.error('Error checking gallery status:', error);
      setIsGalleryEnabled(false);
    } finally {
      setLoading(false);
    }
  };

  // Gallery is hidden - always return false
  return { isGalleryEnabled: false, loading: false, refresh: checkGalleryStatus };
};
